import { api, ApiError } from './client';

export async function joinWaitlist(email: string): Promise<void> {
  try {
    await api.post<{ ok: boolean }>('/waitlist', { email });
  } catch (err) {
    if (err instanceof ApiError) {
      if (err.data && (err.data as { error?: string }).error === 'invalid_email') {
        throw new Error("That doesn't look like a valid email.");
      }
    }
    throw new Error('Something went wrong. Please try again in a moment.');
  }
}
